import { ref, update } from 'firebase/database';
import { database } from '../config/firebase';
import { createLogger } from './logger';

// ログシステム初期化
const logger = createLogger('BulkImport');

/**
 * バルクインポート処理を実行する
 * @param {Object} processedData - 処理されたインポートデータ
 * @param {Object} tasks - 既存のタスクデータ
 * @param {Function} setShowBulkImport - バルクインポート表示状態のsetter
 * @returns {Promise<void>}
 */
export const executeBulkImport = async (processedData, tasks, setShowBulkImport) => {
  try {
    const updates = {};
    for (const [key, data] of Object.entries(processedData)) {
      updates[`tasks/${key}`] = {
        ...tasks[key],
        ...data.tasks,
      };
    }
    await update(ref(database), updates);
    setShowBulkImport(false);
    
    logger.info('バルクインポート成功', {
      processedDataKeys: Object.keys(processedData),
      updateCount: Object.keys(updates).length
    });
  } catch (error) {
    logger.error('Error saving bulk tasks', { 
      error: error.message,
      processedDataKeys: Object.keys(processedData)
    });
    alert('一括登録中にエラーが発生しました。再度お試しください。');
    throw error; // エラーを再スロー
  }
}; 